import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-5 rounded-pill font-mono uppercase leading-100 whitespace-nowrap',
  {
    variants: {
      tone: {
        neutral: 'bg-sunken text-ink-secondary',
        accent: 'bg-accent-wash text-accent',
        success: 'bg-success-wash text-success',
        warning: 'bg-warning-wash text-warning',
        danger: 'bg-danger-wash text-danger',
        info: 'bg-info-wash text-info',
      },
      size: {
        sm: 'h-20 px-10 text-10',
        md: 'h-25 px-10 text-12',
      },
    },
    defaultVariants: { tone: 'neutral', size: 'md' },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, size, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ tone, size }), className)} {...props}>
      {children}
    </span>
  );
}
